import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const EntryPaymentLog = ({
  entryFeeDescription,
  entryFeeAmount,
  addOnFees,
  payments,
  refunds,
  total,
  grandTotal
}) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <h3 className="panel-title">{'Payment Log'}</h3>
    </div>
    <div className="panel-body">
      <div className="flex">
        <div className="flex-3">
          <small>{'Description'}</small>
          <div>{entryFeeDescription}</div>
        </div>
        <div className="flex-1">
          <div className="text-right">
            <small>{'Amount'}</small>
          </div>
          <div className="flex text-right">
            <span className="flex-2"/>
            <strong className="flex-1">{`$${entryFeeAmount.formatCurrency(2)}`}</strong>
          </div>
          {addOnFees.map((fee, index) => (
            <div key={index}
              className="flex text-right">
              <span className="flex-2">{fee.description}</span>
              <span className="flex-1">{
                  fee.amount ? `$${fee.amount.formatCurrency(2)}` : `$${fee.amount}`
                }</span>
            </div>
          ))}
          <div className="flex text-right">
            <strong className="flex-2">{'Total'}</strong>
            <strong className="flex-1">{`$${total.formatCurrency(2)}`}</strong>
          </div>
        </div>
      </div>
        <hr />
      {payments.map((payment, index) => (
        <div key={index}
          className="flex">
          <div className="flex-3">
            <div>{payment.description}</div>
                      {
              payment.notes!=null?
              <div>Notes: {payment.notes}<br/><br/></div>:null
            }
             </div>
          <div className="flex-1">
            <div className="flex text-right">
              <strong className="flex-2">{''}</strong>
              <strong className="flex-1">{`$${(-payment.amount).formatCurrency(2)}`}</strong>
            </div>
          </div>
          </div>
      ))}
      
        {refunds.map((refund, index) => (
          <div key={index}
            className="flex">
            <div className="flex-3">
              <div>{refund.description}</div>
              {
              refund.notes!=null?
              <div>Refund Notes: {refund.notes}<br/><br/></div>:null
            }
            </div>
            <div className="flex-1">
              <div className="flex text-right">
                <strong className="flex-2">{''}</strong>
                <strong className="flex-1">{`$${(-refund.amount).formatCurrency(2)}`}</strong>
              </div>
            </div>
          </div>
        ))}
      <hr />
      <div className="flex">
        <div className="flex-1"> 
          <div className="flex text-right">
            <strong className="flex-2">{'Total Due'}</strong>
            <strong className="flex-1">{`$${grandTotal.formatCurrency(2)}`}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
);

EntryPaymentLog.propTypes = {
  entryFeeDescription: PropTypes.string,
  entryFeeAmount: PropTypes.number,
  addOnFees: PropTypes.arrayOf(PropTypes.object),
  payments: PropTypes.arrayOf(PropTypes.object),
  refunds: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  grandTotal: PropTypes.number
};

EntryPaymentLog.defaultProps = {
  entryFeeDescription: '',
  entryFeeAmount: 0,
  addOnFees: [],
  payments: [],
  refunds: [],
  total: 0,
  grandTotal: 0
};

export default EntryPaymentLog;



// WEBPACK FOOTER //
// ./src/features/shared/EntryPaymentLog.jsx